import { render, staticRenderFns } from "./e-input-document-upload.vue?vue&type=template&id=5bd9f456&lang=pug"
import script from "./e-input-document-upload.vue?vue&type=script&lang=js"
export * from "./e-input-document-upload.vue?vue&type=script&lang=js"
import style0 from "./e-input-document-upload.vue?vue&type=style&index=0&id=5bd9f456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports